import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Upload} from '../interfaces/upload.interface';
import {map, scan} from 'rxjs/operators';
import {calculateState, initialState} from './upload.helper';
import {AttachmentModel} from '@Common/widgets/general/attachments/interfaces/attachment.model';
import {DaoGeneric} from '@Services/base/daoService';
import {ArticleModel} from '@Services/faq';
import {UtilsService} from '@Services/core/utils/utils.service';
import {SlugifyPipe} from '@Common/widgets/pipes';

@Injectable({ providedIn: 'root' })
export class AttachmentService extends DaoGeneric<AttachmentModel> {
  private url = `${environment.baseUrl}/core/attachment_generic/`;
  private tempId = 0;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  getRootUrl(urlApp?: string): string {
    return this.url;
  }
  private _appendFormDataIfExist(formData: FormData, value, fieldName) {
    if (value) {
      formData.append(fieldName, value);
    }
  }
  private _setFormData(attachment: AttachmentModel) {
    const formData: FormData = new FormData();
    formData.append('file', attachment.file, attachment.file.name);
    this._appendFormDataIfExist(formData, attachment.object_id?.toString(), 'object_id');
    this._appendFormDataIfExist(formData, attachment.content_type?.toString(), 'content_type');
    this._appendFormDataIfExist(formData, attachment.user?.toString(), 'user');
    this._appendFormDataIfExist(formData, attachment.application, 'application');
    /*if (attachment.sub_dir?.trim()) {
      attachment.sub_dir = new SlugifyPipe().transform(attachment.sub_dir, 'lower');
    }*/
    this._appendFormDataIfExist(formData, attachment.sub_dir, 'sub_dir');
    this._appendFormDataIfExist(formData, attachment.filename_origin, 'filename_origin');
    return formData;
  }
  upload(attachment: AttachmentModel): Observable<Upload> {
    const formData: FormData = this._setFormData(attachment);
    return this.httpClient
      .post(this.url, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(scan(calculateState, initialState));
  }

  /**
   * Téléchargement d'un fichier de core/attachements
   * @param {AttachmentModel} attachment
   * @param {AttachmentModel} user : optionnel, l'utilisateur à qui appartient le fichier
   */
  download(attachment: AttachmentModel, user: number = null) {
    const url = `${this.url}${attachment.id}/download/`;
    const params = {
      seq: UtilsService.generateSequence()
    };
    if (user) {
      params['user'] = user;
    }
    return this.httpClient.get(url, {responseType: 'blob', params: params}).pipe(
      map((data: any) => new Blob([data]))
    );
  }
  create(attachment: AttachmentModel) {
    const formData: FormData = this._setFormData(attachment);
    return this.httpClient.post<any> (this.url, formData);
  }
  getIdUnique(): number {
    this.tempId++;
    return this.tempId;
  }

}
